import React from 'react';

import { Redirect, Route, useLocation } from 'react-router-dom';

import CustomRedirect from 'components/shared/CustomRedirect';
import { LOGIN_PATH, UNAUTHORIZED_BLOCKED_PATH, UNAUTHORIZED_DELETED_PATH } from 'constants/routes';
import { useAuthentication } from 'hooks/useAuthentication';
import noop from 'utils/noop';

import Backdrop from '../shared/Backdrop';
import Loader from '../shared/Loader';

function AppRoute({ children, getSignInPath = noop, getDeletedPath = noop, ...rest }) {
  const { isSent, isAppLoading, isAuthenticated, isAfterLogout, isUnauthorized, isUserBlocked, isUserDeleted } =
    useAuthentication();
  const loc = useLocation();

  if (isUnauthorized && isUserBlocked) return <Redirect to={{ pathname: UNAUTHORIZED_BLOCKED_PATH }} />;
  if (isUnauthorized && isUserDeleted)
    return <Redirect to={{ pathname: getDeletedPath() ?? UNAUTHORIZED_DELETED_PATH }} />;

  return (
    <Route
      {...rest}
      render={() => {
        if (!isSent || isAppLoading) {
          return (
            <Backdrop isOpen>
              <Loader />
            </Backdrop>
          );
        }

        const to = { pathname: getSignInPath() || LOGIN_PATH };

        if (!isAfterLogout) {
          to.state = { from: loc };
        }

        return isAuthenticated ? (
          <>
            {children}
            {/* temporarily disabled widget while we use UserGuiding instead */}
            {/* maybe one day we'll remove all code for help widget */}
          </>
        ) : (
          <CustomRedirect to={to} />
        );
      }}
    />
  );
}

export default AppRoute;
